$shm_hitalama_map_widget_float_table $shm_hitalama_map_widget_float
	controls /
		<= Table $mol_grid
			records <= rows *
			col_ids <= col_ids /
			col_head_content* <= col_head_content* /
			cell_content_text* => cell_content_text*
			Cell* <= Cell* $mol_view
			row_ids => table_row_ids
	Cell_text* $mol_grid_cell
		sub /
			^ cell_content_text*
			<= Copy_area* $mol_view
				sub /
					<= Cell_copy* $mol_button_copy
						sub / <= Copy_icon* $mol_icon_content_copy
						text <= cell_content_text_str* \
		style <= cell_style* *
			maxWidth <= col_width_px* \auto
			width <= col_width_px* \auto
	Cell_file* $mol_grid_cell
		sub /
			^ cell_file_visible* /
				<= Download* $mol_button_download
					uri <= cell_file_uri* \
					file_name <= cell_file_name* \
					sub /
						<= Download_icon* $mol_icon_download
						<= cell_file_name*
				- <= Download* $mol_link
					uri <= cell_file_uri* \
					file_name <= cell_file_name* \
					sub /
						<= Download_icon* $mol_icon_download
						<= cell_file_name*
		style <= cell_style*
	Cell_index_number* $mol_grid_cell
		sub / <= cell_index_number* \
	Cell_checkbox* $mol_grid_cell
		sub /
			<= Checkbox* $mol_check_box
				checked? <=> cell_checked*? false
	Cell_delete* $mol_grid_cell
		sub /
			^ cell_delete_visible* /
				<= Action_delete* $mol_button_minor
					title \Удалить
					click? <=> cell_delete*? null
	Cell_edit* $mol_grid_cell
		sub /
			<= Action_edit* $mol_button_minor
				title \Редактировать
				click? <=> cell_edit*? null
	All_check $mol_check_group
		checks <= cell_checkboxes /
	checkboxes_showed false
	tools_custom /
		^ deleting_tool_visible / <= Deleting $mol_check_box
			title \Удаление строк
			checked? <=> delete_enabled? false
	settings_content /
		<= Col_widths_head $mol_view
			sub / \Ширина, px
		^ col_width_rows /
			<= Col_width_row* $mol_view
				sub /
					<= Col_width_title* $mol_view
						sub / <= col_settings_title*
					<= Col_width* $mol_number
						Dec null
						Inc null
						value? <=> col_width*? NaN
						hint \auto
	contextmenu_body /
		<= Chart_add $mol_button_minor
			title \Добавить график
			click? <=> chart_add? null
		<= Echarts_add $mol_button_minor
			title \Добавить ECharts
			click? <=> echarts_add? null
		<= Tabulator_add $mol_button_minor
			title \Добавить Tabulator
			click? <=> tabulator_add? null
		^
